import Header from "./navigation/Header";
import Hero from "./sections/Hero";
import Solution from "./sections/Solution";
import Trust from "./sections/Trust";
import Contact from "./sections/Contact";
import Autonomy from "./sections/Autonomy";
import Footer from "./layout/Footer";
import Experience3D from "./sections/Experience3D";
import AutonomyDriveIntro from "./sections/AutonomyDriveIntro";
export default function Mainpage() {
  return (
    <>
  <Header />
  <Hero />
  <Autonomy />
  <AutonomyDriveIntro />
  <Experience3D />
  <Solution />
  <Trust />
  <Contact />
  <Footer />
</>
  );
}